// constants
import { DisabilityActionTypes } from './constants';
import Disability from './model';

const INIT_STATE = {
    disabilities: [],
    loading: false,
    requestStatus: 0,
};

interface DisabilityActionType {
    type:
        | DisabilityActionTypes.API_RESPONSE_SUCCESS
        | DisabilityActionTypes.API_RESPONSE_ERROR
        | DisabilityActionTypes.GET_DISABILITIES;
    payload: {
        actionType?: string;
        data?: Disability | Disability[] | {};
        error?: string;
    };
}

interface State {
    disabilities?: Disability[] | {};
    loading?: boolean;
    requestStatus?: number;
}

const DisabilityReducer = (state: State = INIT_STATE, action: DisabilityActionType): any => {
    switch (action.type) {
        case DisabilityActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DisabilityActionTypes.GET_DISABILITIES: {
                    return {
                        ...state,
                        disabilities: action.payload.data,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case DisabilityActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                default:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        requestStatus: -1,
                    };
            }
        case DisabilityActionTypes.GET_DISABILITIES:
            return { ...state, loading: true, requestStatus: 0 };
        default:
            return { ...state };
    }
};

export default DisabilityReducer;
